import type { ReactNode } from "react";
import styles from "./web-button.module.css";

export function WebButton({
  children,
  className: extraClassName,
  type = "button",
  variant = "filled",
  size = "md",
  disabled,
  onClick,
}: {
  children: ReactNode;
  className?: string;
  type?: "button" | "submit";
  variant?: "filled" | "outlined" | "text" | "disabled" | "danger";
  size?: "sm" | "md";
  disabled?: boolean;
  onClick?: () => void;
}) {
  const variantClassName = {
    filled: styles.filled,
    outlined: styles.outlined,
    text: styles.text,
    disabled: styles.disabled,
    danger: styles.danger,
  }[variant];
  const sizeClassName = size === "sm" ? styles.sm : null;
  const className = [styles.button, variantClassName, sizeClassName, extraClassName]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      className={className}
      disabled={disabled || variant === "disabled"}
      type={type}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
